import {
  IApiResponse,
  TApiPaginatedResponse,
} from "clients/AbstractApiClient/IApiResponse";
import { TApiPaginatedRequest } from "clients/AbstractApiClient/IApiRequest";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetServiceTypesRequestSchema,
  TGetServiceTypesResponseSchema,
  TGetServiceTypeItemResponseSchema,
} from "./getServiceTypes.schema";

export const getServiceTypes = (axios: IAxiosInstance) => {
  async function getServiceTypes(
    params: TApiPaginatedRequest<
      TGetServiceTypesRequestSchema & { serviceTypeID: string }
    >
  ): Promise<IApiResponse<TGetServiceTypeItemResponseSchema>>;

  async function getServiceTypes(
    params: TApiPaginatedRequest<
      TGetServiceTypesRequestSchema & { serviceTypeIDs: string[] }
    >
  ): Promise<IApiResponse<TGetServiceTypesResponseSchema>>;

  async function getServiceTypes(
    params: TApiPaginatedRequest<TGetServiceTypesRequestSchema & { all: true }>
  ): Promise<IApiResponse<TGetServiceTypesResponseSchema>>;

  async function getServiceTypes(
    params: TApiPaginatedRequest<TGetServiceTypesRequestSchema>
  ): Promise<TApiPaginatedResponse<TGetServiceTypesResponseSchema>>;

  async function getServiceTypes(
    params: TApiPaginatedRequest<TGetServiceTypesRequestSchema>
  ): Promise<
    | IApiResponse<TGetServiceTypeItemResponseSchema>
    | IApiResponse<TGetServiceTypesResponseSchema>
    | TApiPaginatedResponse<TGetServiceTypesResponseSchema>
  > {
    if (params.serviceTypeID) {
      const response = await axios.noRetry.get<
        IApiResponse<TGetServiceTypeItemResponseSchema>
      >(`/service-types`, {
        params,
      });
      return response.data;
    }

    if (params.serviceTypeIDs || params.all) {
      const response = await axios.noRetry.get<
        IApiResponse<TGetServiceTypesResponseSchema>
      >(`/service-types`, {
        params,
      });
      return response.data;
    }

    const response = await axios.noRetry.get<
      TApiPaginatedResponse<TGetServiceTypesResponseSchema>
    >(`/service-types`, {
      params,
    });
    return response.data;
  }
  return getServiceTypes;
};
